function syncLoop(list, method, batch_limit = 1, counter = 0) {
  return new Promise((resolve, reject) => {
    if (counter > list.length - 1) resolve();
    else {
      Promise.all(list.slice(counter, counter + batch_limit).map(method))
        .then((res) => {
          resolve(syncLoop(list, method, batch_limit, counter + batch_limit));
        })
        .catch((err) => {
          console.trace(err);
          resolve(syncLoop(list, method, batch_limit, counter + batch_limit))
        });
    }
  })
}

export default syncLoop;


// WEBPACK FOOTER //
// ./src/libs/syncLoop.js